


// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";

// export default function RunningCard({ runnig, winnAmount, game_type }) {
//   const user = localStorage.getItem("userId");

//   // Language translations
//   const translations = {
//     hi: {
//       view: "देखे",
//       prize: "Winning Prize",
//       entry: "Entry Fee",
//     },
//     en: {
//       view: "view",
//       entry: "Entry Fee",
//       prize: "Winning Prize",
//     },
//   };

//   const { language } = useContext(LanguageContext);

//   const creatorName =
//     runnig?.Created_by?.Name?.length > 7
//       ? `${runnig.Created_by.Name.slice(0, 7)}...`
//       : runnig?.Created_by?.Name;

//   const acceptorName =
//     runnig?.Accepetd_By?.Name?.length > 7
//       ? `${runnig.Accepetd_By.Name.slice(0, 7)}...`
//       : runnig?.Accepetd_By?.Name;

//   return (
//     <div className="running-battle-card">
//       {/* Top Header Bar */}
//       <div className="running-card-header">
//         <span className="game-play-title">
//           Game Play between <strong className="player-name">{creatorName}</strong> &{" "}
//           <strong className="player-name">{acceptorName}</strong>
//         </span>
//       </div>

//       {/* Main Card Body */}
//       <div className="running-card-body">
//         {/* Entry Fee Section */}
//         <div className="fee-column left">
//           <span className="fee-label">{translations[language].entry}</span>
//           <div className="fee-amount-row">
//             <img src="/images/moneyrupee.png" alt="cash" className="cash-icon" />
//             <span className="fee-amount">{runnig?.Game_Ammount}</span>
//           </div>
//         </div>

//         {/* Center Versus or View Button */}
//         <div className="center-action-col">
//           {user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id ? (
//             <Link
//               className={`btn-view-match ${
//                 runnig?.Status === "conflict" ? "conflict" : "active"
//               }`}
//               to={{
//                 pathname: `/viewgame1/${runnig?._id}`,
//                 state: { prevPath: window.location.pathname },
//               }}
//             >
//               {translations[language].view}
//             </Link>
//           ) : (
//             <div className="vs-badge-wrapper">
//               <img
//                 className="vs-icon"
//                 src={process.env.PUBLIC_URL + "/images/versus.png"}
//                 alt="VS"
//               />
//             </div>
//           )}
//         </div>

//         {/* Winning Prize Section */}
//         <div className="fee-column right">
//           <span className="fee-label">{translations[language].prize}</span>
//           <div className="fee-amount-row justify-end">
//             <img src="/images/moneyrupee.png" alt="cash" className="cash-icon" />
//             <span className="fee-amount">
//               {runnig?.Game_Ammount + winnAmount(runnig?.Game_Ammount)}
//             </span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
// import css from "./RunningCard.module.css";
import css from "../Modulecss/Home.module.css";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");

  // Language translations
  const translations = {
    hi: {
      view: "देखे",
      prize: "Winning Prize",
      entry: "Entry Fee",
    },
    en: {
      view: "view",
      entry: "Entry Fee",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  const creatorName =
    runnig?.Created_by?.Name?.length > 7
      ? `${runnig.Created_by.Name.slice(0, 7)}...`
      : runnig?.Created_by?.Name;

  const acceptorName =
    runnig?.Accepetd_By?.Name?.length > 7
      ? `${runnig.Accepetd_By.Name.slice(0, 7)}...`
      : runnig?.Accepetd_By?.Name;

  return (
    <div className={css.runningBattleCard}>
      {/* Top Header Bar */}
      <div className={css.runningCardHeader}>
        <span className={css.gamePlayTitle}>
          Game Play between <strong className={css.playerName}>{creatorName}</strong> &{" "}
          <strong className={css.playerName}>{acceptorName}</strong>
        </span>
      </div>

      {/* Main Card Body */}
      <div className={css.runningCardBody}>
        {/* Entry Fee Section */}
        <div className={`${css.feeColumn} ${css.left}`}>
          <span className={css.feeLabel}>{translations[language]?.entry || "Entry Fee"}</span>
          <div className={css.feeAmountRow}>
            <img src="/images/moneyrupee.png" alt="cash" className={css.cashIcon} />
            <span className={css.feeAmount}>{runnig?.Game_Ammount}</span>
          </div>
        </div>

        {/* Center Versus or View Button */}
        <div className={css.centerActionCol}>
          {user === runnig?.Accepetd_By?._id || user === runnig?.Created_by?._id ? (
            <Link
              className={`${css.btnViewMatch} ${
                runnig?.Status === "conflict" ? css.conflict : css.active
              }`}
              to={{
                pathname: `/viewgame1/${runnig?._id}`,
                state: { prevPath: window.location.pathname },
              }}
            >
              {translations[language]?.view || "view"}
            </Link>
          ) : (
            <div className={css.vsBadgeWrapper}>
              <img
                className={css.vsIcon}
                src={process.env.PUBLIC_URL + "/images/versus.png"}
                alt="VS"
              />
            </div>
          )}
        </div>

        {/* Winning Prize Section */}
        <div className={`${css.feeColumn} ${css.right}`}>
          <span className={css.feeLabel}>{translations[language]?.prize || "Winning Prize"}</span>
          <div className={`${css.feeAmountRow} ${css.justifyEnd}`}>
            <img src="/images/moneyrupee.png" alt="cash" className={css.cashIcon} />
            <span className={css.feeAmount}>
              {runnig?.Game_Ammount + winnAmount(runnig?.Game_Ammount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}